<template>
	<v-container id="installment-import-view" fluid tag="section">
		<material-card icon="mdi-upload" icon-small title="دریافت فایل اکسل وام ها و اقساط" color="accent">
			<v-card-text>
				<v-row>
					<v-col cols="12">
						<div class="text-h5">
							لطفا فایل اکسل مورد نظر خود را با رعایت ترتیب ستون های زیر، انتخاب کنید.
						</div>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" class="text-center">
						<span v-for="(col, index) in columns" :key="col" class="info--text px-2" :class="{ 'border-left': index < columns.length - 1 }">
							{{ col }}
							<v-tooltip top v-if="col == 'نوع پرداخت'">
								<template v-slot:activator="{ on, attrs }">
									<v-btn fab dark x-small color="secondary" outlined class="mr-2" style="">
										<v-icon dark v-bind="attrs" v-on="on">
											mdi-information
										</v-icon>
									</v-btn>
								</template>
								<span>
									1: نقدی<br />
									2: کارت به کارت / حواله<br />
									3: طلا<br />
									4: آنلاین<br />
									5: کارتخوان
								</span>

							</v-tooltip>
							<v-tooltip top v-if="col == 'تاریخ واریز'">
								<template v-slot:activator="{ on, attrs }">
									<v-btn fab dark x-small color="secondary" outlined class="mr-2" style="">
										<v-icon dark v-bind="attrs" v-on="on">
											mdi-information
										</v-icon>
									</v-btn>
								</template>
								<span>
									فرمت تاریخ واریز باید به صورت yyyy/mm/dd باشد. مثال: 1404/10/10
								</span>

							</v-tooltip>
						</span>
					</v-col>
				</v-row>
				<v-form ref="form" lazy-validation>
					<v-row align="center" justify="center">
						<v-col cols="12" sm="6">
							<v-file-input ref="file" v-model="file" :rules="[value => !!value || 'ابتدا فایل را انتخاب کنید.']" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" placeholder="" prepend-icon="mdi-file-excel-outline" label="جهت انتخاب فایل اینجا را کلیک کنید" />
						</v-col>
						<v-col cols="12" sm="2">
							<v-btn color="info" dark :loading="previewLoading" @click="preview">
								<v-icon dark>
									mdi-upload
								</v-icon>
								بارگذاری و پیش نمایش
							</v-btn>
						</v-col>
					</v-row>
				</v-form>
				<v-row v-if="localData.installmentImportPreviewModels.length > 0" class="mt-3">
					<v-col cols="12" style="max-height:300px; overflow-y:auto">
						<div class="text-h5 primary--text text-center mt-3 mb-3">
							لطفا پیش نمایش اطلاعات را بررسی کنید و در صورت تایید، بر روی دکمه تایید (پایین جدول) کلیک کنید.
						</div>
						<v-data-table :headers="headers" :items="localData.installmentImportPreviewModels" :items-per-page="500" class="elevation-1">
							<template v-slot:item="row">
								<tr>
									<td class="primary--text">
										{{ row.item.systemMsg }}
									</td>
									<td class="text-center">
										{{ row.item.nationalCode }}
										<div class="grey--text"><small>{{ row.item.fullName }}</small></div>
									</td>
									<td class="text-center">
										{{ row.item.userLoanCode }}
									</td>
									<td class="text-center">
										{{ row.item.installmentNumber }}
									</td>
									<td class="text-center">
										{{ row.item.installment.toString().toPriceFormat() }}
									</td>
									<td class="text-center">
										{{ row.item.paymentDate }}
									</td>
									<td class="text-center">
										{{ getPaymentMethodText(row.item.paymentMethod) }}
									</td>
								</tr>
							</template>
						</v-data-table>
						<div class="text-center pt-3">
							<v-btn color="info" dark :loading="submitLoading" @click="submit">
								<v-icon dark>
									mdi-upload
								</v-icon>
								تایید
							</v-btn>
						</div>
					</v-col>
				</v-row>
				<v-row v-if="summery">
					<v-col cols="12">
						<div class="text-success">
							تعداد قسط ایجاد شده: {{ summery.paymentNew }}
						</div>
						<div class="text-success">
							تعداد قسط ویرایش شده: {{ summery.paymentUpdate }}
						</div>
						<div v-if="summery.failed != 0" class="primary--text">
							تعداد ناموفق: {{ summery.failed }}
						</div>
						<div v-if="summery.errors.length > 0" class="primary--text">
							خطاها:
							<div v-for="err in summery.errors" :key="err">
								{{ err }}
							</div>
						</div>
					</v-col>
				</v-row>
			</v-card-text>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'InstallmentImportView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		data() {
			return {
				columns: ['کد ملی', 'شماره وام', 'شماره قسط', 'مبلغ قسط', 'تاریخ واریز', 'نوع پرداخت'],
				file: null,
				errorMessages: '',
				previewLoading: false,
				submitLoading: false,
				localData: {
					installmentImportPreviewModels: [],
				},
				headers: [
					{
						text: 'پیام سیستم',
						align: 'right',
						sortable: true,
						value: 'systemMsg',
						width: 200,
					},
					{
						text: 'کد ملی',
						align: 'center',
						sortable: true,
						value: 'nationalCode',
					}, {
						text: 'شماره وام',
						align: 'center',
						sortable: true,
						value: 'userLoanCode',
					}, {
						text: 'شماره قسط',
						align: 'center',
						sortable: true,
						value: 'installmentNumber',
					}, {
						text: 'مبلع واریزی',
						align: 'center',
						sortable: true,
						value: 'installment',
					}, {
						text: 'تاریخ واریز',
						align: 'center',
						sortable: true,
						value: 'paymentDate',
					}, {
						text: 'نوع پرداخت',
						align: 'center',
						sortable: true,
						value: 'paymentMethod',
					},
				],
				loans: [],
				summery: null,
				paymentMethods: [
					{ id: 1, title: 'نقدی' },
					{ id: 2, title: 'واریز بانکی' },
					{ id: 3, title: 'طلا' },
					{ id: 4, title: 'آنلاین' },
					{ id: 5, title: 'کارتخوان' },
				]
			}
		},
		mounted() {
			this.loadLoans()
		},
		methods: {
			preview() {
				if (!this.$refs.form.validate()) { return }
				this.summery = null
				const formData = new FormData()
				formData.append('file', this.file)
				this.previewLoading = true
				api.post('admin/import/InstallmentImportPreview', formData, { contentType: 'multipart/form-data' })
					.then(
						response => {
							this.localData.installmentImportPreviewModels = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.previewLoading = false })
			},
			loadLoans() {
				api.get('admin/loan/list', null)
					.then(
						response => {
							this.loans = response
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			submit() {
				if (!this.$refs.form.validate()) { return }
				this.summery = null
				this.submitLoading = true
				api.post('admin/import/InstallmentImportSubmit', this.localData)
					.then(
						response => {
							this.localData.installmentImportPreviewModels = []
							toast.success('اطلاعات با موفقیت ذخیره شد.')
							this.summery = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.submitLoading = false })
			},
			getPaymentMethodText(id) {
				return this.paymentMethods.find(x => x.id === id)?.title || 'نامشخص'
			}
		},
	}
</script>
<style>
	.border-left {
		border-left: 1px solid #ddd;
	}
</style>
